/**
 * Generate the correct indefinite article (a or an) based on a given string.
 * A for words that begin with a consonant, an for words that being with a vowel.
 *
 * Note: There are edge case exceptions to this rule that we don't account for.
 *
 * @param str The string to check.
 * @returns "an" or "a" depending on the given string.
 */
export const aOrAn = (str: string) => {
  if (!str) {
    return ''
  }

  return ['a', 'e', 'i', 'o', 'u'].includes(str[0].toLowerCase()) ? 'an' : 'a'
}

export const shortManufacturerApp = (manufacturerApp: string) =>
  manufacturerApp.replace('and Driver by High Mobility', '')
